import rootSaga from './rootSaga';

export default rootSaga;
